module.exports = __webpack_public_path__ + "img/swiper-banner1.58c49136.webp";